import styled from "styled-components";

export const PageWrapper = styled.div`
    max-width: 800px;
    width: 100%;
    margin: auto;

    font-family: Poppins, sans-serif;
`;
